import { boostTiers } from "components/Pages/Boost/consts";

// Order matters. Keep tiers in
// order of shortest -> longest tiers
export const BoostTermNames = {
  monthly: "monthly",
  yearly:"yearly",
};

/**
 *
 * @param {string} currentTier
 * @param {string} newTier
 * @returns {boolean} canDowngrade indicating if boost subscription can be downgraded to given tier
 */
export const canDowngradeTier = (currentTier, newTier) => {
  const tiers = [...Object.keys(boostTiers)];
  const isTierLowerThan =
      tiers.find((tier) => tier === newTier) <=
      tiers.find((tier) => tier === currentTier);
  return isTierLowerThan;
};

/**
 *
 * @param {string} currentTerm
 * @param {string} newTerm
 * @returns {boolean} canDowngrade indicating if boost subscription can be downgraded to given term
 */
export const canDowngradeTerm = (currentTerm, newTerm) => {
  const terms = [...Object.keys(BoostTermNames)];
  const isTermLowerThan =
      terms.find((term) => term === newTerm) <=
      terms.find((term) => term === currentTerm);
  return isTermLowerThan;
};

export const tierColors = {
  [boostTiers.BASIC]: "bg-black",
  [boostTiers.PLUS]: "bg-blue-500",
  [boostTiers.PREMIUM]: "bg-purple-600",
  [boostTiers.VIP]: "bg-yellow-600",
};

export const termColors = {
  monthly: "bg-gray-600",
  yearly: "bg-black",
};